import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const technologies = [
  'Python',
  'C#',
'Winforms',
'WPF',
"...",
]

const skills = [
  'Dynamo / DynamoAPI',
  'Unity',
  'AR / VR',
  'Revit / RevitAPI',
  'Print3D / Scan3D',
  'Linux / Windows',
  "Point Clouds",
  "AutoCAD API / Navisworks API/ Recap",
  "Mechanical, Electrical, and Plumbing (MEP)",
"Data Science",
"Machine Learning",
]

export default () => (
  <section className="py-8 bg-gray-100">
    <div className="container max-w-6xl px-3">
      <h2 className="uppercase text-center text-4xl mb-8">Skills</h2>

      <div className="flex flex-wrap">
        <div className="w-full md:w-1/2 sm:px-8">
          <h3 className="mb-4 border-b pb-4">Development</h3>
          <ul className="leading-loose">
            {technologies.map((technology, i) => (
              <li key={i} className="flex items-center">
                <FontAwesomeIcon
                  fixedWidth
                  className="text-indigo-500 mr-2"
                  icon={['far', 'check-circle']}
                />{' '}
                {technology}
              </li>
            ))}
          </ul>
        </div>

        <div className="w-full md:w-1/2 sm:px-8 md:mt-0 mt-8">
          <h3 className="mb-4 border-b pb-4">Knowledge </h3>
          <ul className="leading-loose">
            {skills.map((skill, i) => (
              <li key={i} className="flex items-center">
                <FontAwesomeIcon
                  fixedWidth
                  className="text-indigo-500 mr-2"
                  icon={['far', 'check-circle']}
                />{' '}
                {skill}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </section>
)
